import { useEffect, useRef } from 'react'
import { useNetworkStatus } from '@dostavkee/web-ui'
import { toast } from 'sonner'

export function NetworkStatus() {
    const { isOffline, isOnline } = useNetworkStatus()

    const toastIdRef = useRef<string | number | null>(null)

    /**
     * Показываем toast, если интернет пропал
     */
    useEffect(() => {
        if (isOffline) {
            toastIdRef.current = toast.warning(
                'Проблемы с интернетом. Пожалуйста, проверьте ваше соединение',
                {
                    duration: 0,
                }
            )
        }
    }, [isOffline])

    /**
     * Скрываем toast, если интернет восстановился
     */
    useEffect(() => {
        if (isOnline && toastIdRef.current) {
            toast.dismiss(toastIdRef.current)
            toastIdRef.current = null

            /**
             * Если ранее был показан toast, то скрываем его
             */
        }
    }, [isOnline])

    return null
}
